"use client";
import { useEffect } from 'react';
import getBridge from '@/services/jsbridge';

const useShare = (store) => {
  const { title, desc, image, link } = store.shareData || {};

  const setShareInfo = () => {
    getBridge().then((Bridge) => {
      Bridge.setShareInfo({
        desc,
        title,
        imgUrl: image,
        link: link || window.location.href,
      });
    });
  };

  useEffect(() => {
    setShareInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setShareInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store.shareData]);
};

export default useShare;
